import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";
import Link from "next/link";
import React from "react";

import { formatCurrency } from "../../core/currency.core";
import { getPosUserOrders } from "../../core/posCustomer.core";
import { useTranslation } from "../../core/translation.core";
import { OrderStatus } from "../orders/orderStatus.comp";
import { CustomerItem } from "../../types/customer";

export default function CustomerOrders({ user }: { user: CustomerItem }) {
  const { t, msg } = useTranslation();

  const { data } = useQuery({
    queryFn: () => getPosUserOrders(user.id),
    queryKey: ["customer", user.id],
  });
  const orders = data?.orders;

  if (orders?.length === 0) return <div className="text-2xl text-center font-medium">Customer has no orders yet</div>;
  return (
    <div>
      {orders?.map((order) => (
        <section key={order.id || order._id} id="order-list__item" className="space-y-4">
          <div className="block px-2 lg:flex justify-between items-center font-medium py-4 border-b-2">
            <section className="space-y-3">
              <Link
                href={`/new-order/checkout?orderId=${order.id || order._id}`}
                className="text-base cursor-pointer underline-offset-4 underline text-her-blue"
              >
                {order?.orderNumber} <span>({order.products.length})</span>
              </Link>

              <div className="text-sm items-center flex tracking-wider">
                <span>{format(new Date(order?.createdAt), "yyyy/MM/dd HH:mm:ss")}</span>
              </div>
            </section>

            <OrderStatus status={order?.status} pickup={order?.isPickedUp} />

            <div className="space-y-3 text-center w-auto tracking-wide">
              <h1 className="text-lg">{formatCurrency(order.total, "HKD")}</h1>
              <h6 className="text-sm">
                {order.products.length} {t(msg.pos.items)}
              </h6>
            </div>
          </div>
        </section>
      ))}
    </div>
  );
}
